import {createFileRoute} from '@tanstack/react-router';

import PatientUserProfile from '@/patient/views/user/UserProfile';
import PractitionerUserProfile from '@/practitioner/views/user/UserProfile';
import {useIsPatient} from '@/shared/contexts/UserContext/useUserContext';

function UserProfileWrapper() {
  const isPatient = useIsPatient();
  return isPatient ? <PatientUserProfile /> : <PractitionerUserProfile />;
}

export const Route = createFileRoute('/(shared)/profile')({
  component: UserProfileWrapper
});
